export default {"src":"/_next/static/media/0x7829a9810bb84b0e6827f21c81396125d76a2eab.7d533968.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};